export default "__VITE_ASSET__CtzhCF4y__"